import { render, staticRenderFns } from "./OrderListFiltersChip.vue?vue&type=template&id=69bcaa70&scoped=true&lang=pug&"
import script from "./OrderListFiltersChip.vue?vue&type=script&lang=js&"
export * from "./OrderListFiltersChip.vue?vue&type=script&lang=js&"
import style0 from "./OrderListFiltersChip.vue?vue&type=style&index=0&id=69bcaa70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bcaa70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VContainer,VIcon,VSpacer})
